<template>
  <div class="p-4 bg-white text-xs hover:bg-gray-50 group cursor-pointer" @click="handleView">
    <div class="flex justify-between">
      <div>
        <span class="text-gray-600">From: </span>
        <span class="text-gray-700 font-medium">{{ fromAddress }}</span>
      </div>
      <div>
        <span>
          {{ sentAt }}
        </span>
      </div>
    </div>
    <div class="flex justify-between mt-2">
      <div>
        <span class="text-gray-600">Subject: </span>
        <span class="text-gray-700 font-medium">{{ emailMessage.subject || 'N/A' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    emailMessage: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sentAt() {
      return moment.utc(this.emailMessage.sent_at).local().format('DD/MM/YYYY HH:mm');
    },
    sentAtFromNow() {
      return moment.utc(this.emailMessage.sent_at).local().fromNow();
    },
    fromAddress() {
      return this.emailMessage?.third_party_service?.config?.from_email || 'N/A';
    },
  },
  methods: {
    handleView() {
      this.$emit('view', this.emailMessage);
    },
  },
};
</script>
